/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16.038 22C19.325 22 22 19.31 22 16.002V14c0-1.654-1.338-3-2.982-3-.348 0-.683.06-.994.171V10c0-1.654-1.338-3-2.982-3-.348 0-.683.06-.994.171V5c0-1.654-1.338-3-2.982-3-1.644 0-2.982 1.346-2.982 3v4.586l-.788-.793a3.093 3.093 0 0 0-4.387 0C2.322 9.382 2 10.166 2 11s.322 1.618.909 2.207l1.49 1.5 2.676 3.146A11.765 11.765 0 0 0 16.038 22zm-3.978-9h1.988v-3c0-.552.445-1 .994-1s.994.448.994 1v5h1.988v-1c0-.552.445-1 .994-1 .549 0 .994.448.994 1v2.002c0 2.204-1.782 3.998-3.974 3.998a9.783 9.783 0 0 1-7.453-3.448L5.857 13.35l-1.543-1.557A1.119 1.119 0 0 1 3.988 11a1.116 1.116 0 0 1 1.902-.793l2.485 2.5a.985.985 0 0 0 1.084.217 1 1 0 0 0 .613-.924V5c0-.552.445-1 .994-1s.994.448.994 1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHandUp as HandUp };
